import React, { useState, useEffect } from "react";
import { getLabelData } from "../../../../api/DzoneApi";
import QRCode from "qrcode";
import {
  generateShippingLabelsPDF,
  generateOrderSheetPDF,
} from "../../../../api/pdf";
import createDownloadLink from "../../../../util/createDownloadLink";
import { AdminQuoteObj } from "./TableToolbar";

function useToolbarSelector(quote?: AdminQuoteObj[], numSelected?: number) {
  const role = JSON.parse(sessionStorage.getItem("role") || JSON.stringify(""));

  const [open, setOpen] = useState(false);

  const [loadShippingLabels, setLoadShipLabels] = useState(false);
  const [loadCncLabels, setLoadCncLabels] = useState(false);
  const [loadOrderSheet, setLoadOrderSheet] = useState(false);

  const handleOpenGlass = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    setLoadShipLabels(false);
    setLoadCncLabels(false);
    setLoadOrderSheet(false);
  }, [numSelected]);

  const handleClick = async () => {
    if (!quote?.length) return;

    setLoadOrderSheet(true);
    try {
      const res = await generateOrderSheetPDF(quote[0]._id);
      createDownloadLink(
        res.data,
        `AGMillworks(OS-${quote[0].salesOrder}).pdf`
      );
    } catch (err) {
      console.log(err);
    } finally {
      setLoadOrderSheet(false);
    }
  };

  const handleClickShipLabels = async () => {
    if (!quote || !quote[0] || role !== "Admin") return;

    setLoadShipLabels(true);

    const url =
      process.env.NODE_ENV === "production"
        ? `https://agdealerzone.com/installDetails/${quote[0]._id}`
        : `http://192.168.1.182:3000/installDetails/${quote[0]._id}`;

    try {
      const qrSrc = await QRCode.toDataURL(url);
      const res = await generateShippingLabelsPDF({
        quoteId: quote[0]._id,
        qrCode: qrSrc,
      });
      createDownloadLink(
        res.data,
        `AGMillworks(ShippingLabel-${quote[0].salesOrder}).pdf`
      );
    } catch (err) {
      console.log(err);
    } finally {
      setLoadShipLabels(false);
    }
  };

  const handleClickLabels = async (salesOrder: string) => {
    setLoadCncLabels(true);
    try {
      const res = await getLabelData(salesOrder);
      createDownloadLink(res.data, `AGMillworks(LS-${salesOrder}).pdf`);
    } catch (err) {
      console.log(err);
    } finally {
      setLoadCncLabels(false);
    }
  };

  return {
    handleClick,
    handleClickLabels,
    handleClickShipLabels,
    handleClose,
    handleOpenGlass,
    loadOrderSheet,
    loadCncLabels,
    loadShippingLabels,
    open,
    role
  };
}

export default useToolbarSelector;
